import { render, staticRenderFns } from "./base-carousel-slide.vue?vue&type=template&id=a9d947dc"
import script from "./base-carousel-slide.vue?vue&type=script&lang=js"
export * from "./base-carousel-slide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports